import { Navigate } from 'react-router-dom'
import { useAppSelector } from '@app/hooks/reduxHooks'
import { WithChildrenProps } from '@app/types/general-types'
import ConsentGate from './consent-gate'

const RequireAuth = ({ children }: WithChildrenProps) => {
  const token = useAppSelector((state) => state.auth?.token)

  if (!token) return <Navigate to='/auth/login' replace />

  return <ConsentGate>{children}</ConsentGate>
}

export default RequireAuth
